// MUI
import { Box, Grid2, Stack } from '@mui/material';

// Third party
import { useForm } from 'react-hook-form';
import dayjs from 'dayjs';
import { yupResolver } from '@hookform/resolvers/yup';

// Components
import { RHFTextField, FormProvider, RHFDatePicker, RegisterSchema } from '../../../../components/form';
import { RegisterActionButtons } from './RegisterActionButtons';

// Hooks
import { useBoolean } from '../../../../hooks';
import { useRegisterAPI } from '../../../../hooks/API/welcome';

const RegisterForm = () => {
  const isEulaAgreed = useBoolean();
  const submitAttempted = useBoolean();

  const methods = useForm({
    resolver: yupResolver(RegisterSchema),
    defaultValues: {
      username: '',
      first_name: '',
      last_name: '',
      email: '',
      phone: '',
      password: '',
      retypePassword: '',
      date_of_birth: undefined
    },
    mode: 'onChange',
  });

  const { handleSubmit, formState } = methods;
  const { isSubmitting } = formState;

  const { mutate: register, isPending: registerLoading } = useRegisterAPI();

  const onSubmit = handleSubmit(data => {
    if (!isEulaAgreed.value) {
      submitAttempted.onTrue();
      return;
    }
    submitAttempted.onFalse();

    const payload = {
      username: data.username,
      email: data.email,
      password: data.password,
      first_name: data.first_name,
      last_name: data.last_name,
      phone: data.phone,
      date_of_birth: dayjs(data.date_of_birth).format("YYYY-MM-DD"),
    };

    register(payload);
  });

  return (
    <Box sx={{ width: '100%' }}>
      <FormProvider methods={methods} onSubmit={onSubmit}>
        <RHFTextField name="username" placeholder="Username" />

        <Grid2 container spacing={2} my={2}>
          <Grid2 size={{ xs: 12, sm: 6 }}>
            <RHFTextField name="first_name" placeholder="First Name" />
          </Grid2>
          <Grid2 size={{ xs: 12, sm: 6 }}>
            <RHFTextField name="last_name" placeholder="Last Name" />
          </Grid2>
          <Grid2 size={{ xs: 12, sm: 6 }}>
            <RHFTextField type="email" name="email" placeholder="Email" />
          </Grid2>
          <Grid2 size={{ xs: 12, sm: 6 }}>
            <RHFTextField type='tel' name="phone" placeholder="Phone" />
          </Grid2>
        </Grid2>

        <Stack spacing={2} mb={2}>
          <RHFTextField type="password" name="password" placeholder="Password" />
          <RHFTextField type="password" name="retypePassword" placeholder="Retype Password" />
          <RHFDatePicker name="date_of_birth" label="Date of Birth" />
        </Stack>

        <RegisterActionButtons
          isEulaAgreed={isEulaAgreed}
          registerLoading={registerLoading}
          isSubmitting={isSubmitting}
          submitAttempted={submitAttempted}
        />
      </FormProvider>
    </Box>
  );
};

export { RegisterForm };